import React, { useState, useEffect } from 'react'

const FRAMES = ['|', '/', '-', '\\']

export const LoadingSpinner: React.FC = () => {
  const [frame, setFrame] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setFrame((f) => (f + 1) % FRAMES.length)
    }, 120)
    return () => clearInterval(interval)
  }, [])

  return (
    <span
      style={{
        color: 'var(--accent-green)',
        fontFamily: "'JetBrains Mono', 'Courier New', monospace",
        fontSize: '1.1rem',
        display: 'inline-block',
        width: '1ch',
        textAlign: 'center',
        userSelect: 'none',
      }}
      aria-label="Loading"
      role="status"
    >
      {FRAMES[frame]}
    </span>
  )
}
